module.exports = __webpack_public_path__ + "img/40_00_085_520.e5cfd004.jpg";